export default __webpack_public_path__ + "static/media/background3.a425fef0.webp";